import { Component, OnDestroy } from '@angular/core';
import { LayoutService } from '@shared/services/layout.service';
import { translates } from '@shared/translation';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { fadeTopBottom } from '@shared/animations/fade-bottom-top';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HelperService } from '@shared/helpers/helper.service';

@Component({
  selector: 'app-language-switch',
  templateUrl: './language-switch.component.html',
  styleUrls: ['./language-switch.component.scss'],
  animations: [
    fadeTopBottom
  ]
})
export class LanguageSwitchComponent implements OnDestroy {
  private destroy$ = new Subject<void>();
  translates = translates;

  constructor(public layoutService: LayoutService,
              public translate: TranslateService,
              public helper: HelperService) {
    translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: LangChangeEvent) => {
        translate.get('englishStr')
          .subscribe((res: string) => {
            this.translates[0].name = res; //todo refactoring
          });

        translate.get('frenchStr')
          .pipe(takeUntil(this.destroy$))
          .subscribe((res: string) => {
            this.translates[1].name = res; //todo refactoring
          });
      });
  }

  onLangSwitch(lang: string) {
    if (this.layoutService.lang !== lang) {
      this.layoutService.changeLanguage(lang);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
